import React from 'react';
import { Link } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';

function PartnerSwitcher() {
  const { memberships, activeTenantId, setActiveTenant, sessionLoading } = useAuth();

  if (sessionLoading) {
    return null;
  }

  return (
    <div className="d-flex align-items-center gap-2">
      {memberships.length === 0 ? (
        <span className="text-light small">No partner</span>
      ) : memberships.length === 1 ? (
        <span className="text-light small">
          {memberships[0].partner_name || memberships[0].tenant_name}
          {memberships[0].role ? ` · ${memberships[0].role}` : ''}
        </span>
      ) : (
        <Form.Select
          size="sm"
          className="console-tenant-select"
          aria-label="Active partner"
          value={activeTenantId || ''}
          onChange={(e) => setActiveTenant(e.target.value)}
        >
          {memberships.map((m) => {
            const suspended =
              m.partner_status === 'suspended' || m.tenant_status === 'suspended';
            return (
              <option key={m.tenant_id} value={m.tenant_id} disabled={suspended}>
                {m.partner_name || m.tenant_name}
                {m.role ? ` (${m.role})` : ''}
                {suspended ? ' — suspended' : ''}
              </option>
            );
          })}
        </Form.Select>
      )}
      <Link to="/console/partners/new" className="small text-light text-decoration-none">
        Create partner…
      </Link>
    </div>
  );
}

export default PartnerSwitcher;
